import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';


/**
 * workaround to fix [autofocus] on dynamically created components like modals
 */
@Directive({
    selector: '[autofocus]',
})
export class AutofocusDirective implements AfterViewInit {

    constructor(private element: ElementRef, private renderer: Renderer2) {
        // fix warning about blocked autofocus processing while document's URL has a fragment
        // by removing the autofocus attribute before it's inserted into document
        this.renderer.removeAttribute(this.element.nativeElement, 'autofocus');
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.element.nativeElement.focus();
        });
    }
}
